require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#997c0f',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56ca00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        customize: '#0dcaf5',
      },
      dark: {
        primary: '#72580c',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        customize: '#0dcaf5',
      },
    },
  },
}
